import { Col, Grid, Row, useIsMobile } from '@yes.technology/react-toolkit'
import Tabs from 'component/Tabs'
import { TabItem } from 'component/Tabs/Tabs.types'
import { useCallback, useMemo, useState } from 'react'
import useDeviceType from 'shared/hooks/useDeviceType'
import { StyledGrid } from 'shared/style/grid'
import { HeightClass } from 'shared/types/toolkit'
import useStyleMaps from 'site/Renderer/hooks/useStyleMap'
import { TabSubtitle } from './TabsContent.styles'
import { Tab, TabsContentProps } from './TabsContent.types'
import TabsContentItem from './TabsContentItem'

const defaultHeightClassMap: Record<string, HeightClass> = {
  mobile: 'regular',
  tablet: 'regular',
  desktop: 'large'
}

const getTabs = (items: Record<string, Tab>): TabItem[] =>
  Object.entries(items).map(([title, tab]) => ({
    uuid: tab?.uuid,
    des: title
  }))

function TabsContent({ props }: TabsContentProps) {
  const {
    items,
    highlightColor,
    showSeparators,
    contentContainerStyleMap = {},
    heightClassMap = defaultHeightClassMap
  } = props
  const [currentTab, setCurrenTab] = useState<TabItem>(getTabs(items)[0])
  const isMobile = useIsMobile()
  const deviceType = useDeviceType()

  const styleProps = useStyleMaps(props.styleMap)

  const tabs = useMemo(() => getTabs(items), [items])

  const onTabSelected = useCallback((tab: TabItem) => {
    setCurrenTab(tab)
  }, [])

  const currentTabName = currentTab?.des ?? ''

  return (
    <StyledGrid style={styleProps}>
      <Row>
        <Col className='d-flex flex-column align-items-center'>
          <Tabs
            items={tabs}
            selectedItem={currentTab}
            onItemSelect={onTabSelected}
            highlightColor={highlightColor}
            heightClass={heightClassMap[deviceType]}
            showSeparators={showSeparators}
            contentContainerStyleMap={contentContainerStyleMap}
          />

          {!!currentTabName && !items[currentTabName].components && (
            <TabSubtitle
              variant={isMobile ? 'content-emphasis-06' : 'content-emphasis-07'}
            >
              {items[currentTabName].des}
            </TabSubtitle>
          )}

          <Grid>
            <Row className='justify-content-center'>
              <Col md={10}>
                <TabsContentItem items={items} currentKey={currentTabName} />
              </Col>
            </Row>
          </Grid>
        </Col>
      </Row>
    </StyledGrid>
  )
}

export default TabsContent
